module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/profile_image_sample-1751bab76b51a369e85bb7cb07f169d3.png";